// Un solo formato de precio para todo el marketplace. Antes convivían «$50.000» (tarjetas),
// «ARS 50.000» (perfil) y «$23.000 ARS» (tipo de servicio).
//
// - Pesos argentinos, la moneda de casi todos los negocios: «$50.000», sin código.
// - Cualquier otra moneda lleva el código ISO adelante, para que nadie lea pesos uruguayos o
//   chilenos como argentinos: «UYU 1.500», «CLP 15.000», «USD 25» (USD con centavos si los tiene).
// Separador de miles con punto (es-AR) en todos los casos.

const KNOWN = new Set(['ARS', 'UYU', 'CLP', 'USD']);

/** Código de moneda normalizado; lo desconocido o vacío cuenta como ARS. */
export function normalizeCurrency(currency) {
  const code = String(currency || '').trim().toUpperCase();
  return KNOWN.has(code) ? code : 'ARS';
}

/** «$50.000», «UYU 1.500», «USD 25,50». Vacío si el monto no es un número. */
export function formatPrice(amount, currency = 'ARS') {
  const value = Number(amount);
  if (amount === null || amount === undefined || amount === '' || !Number.isFinite(value)) return '';
  const code = normalizeCurrency(currency);
  const hasCents = code === 'USD' && Math.round(value * 100) % 100 !== 0;
  const number = value.toLocaleString('es-AR', {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0
  });
  return code === 'ARS' ? `$${number}` : `${code} ${number}`;
}

/** «$20.000 a $50.000» (o uno solo si son iguales). */
export function formatPriceRange(min, max, currency = 'ARS') {
  const from = formatPrice(min, currency);
  const to = formatPrice(max, currency);
  if (!from || !to) return from || to;
  return from === to ? from : `${from} a ${to}`;
}
